import React, {FC} from 'react';
import {Dexa} from 'templates/reports/query';
import InfoCard from 'templates/reports/Summary/InfoCard';
import {DexaMetric, Section as Config} from 'templates/reports/types';

import ImagesCard from './InfoCard/ImagesCard';
import {RegionalCard} from './InfoCard/RegionalCard';

import * as styles from './styles.module.scss';

interface SummaryProps {
	data: Dexa
	sections: Config[]
}

const Summary: FC<SummaryProps> = ({data, sections}) => {
	const showImages = data.images && data.images.length > 0;
	return (
		<div className={styles.wrapper}>
			{showImages && data.sections?.[0].results?.[0] && (
				<ImagesCard
					date={data.sections[0].results[0].start.short}
				/>
			)}
			{sections
				.map((s) => ({
					card: s.details.card,
					data: data.sections.find((v) => v.metric === s.metric),
					reverse: s.reverse,
				}))
				.filter((s) => s.card && s.data)
				.map((p, i) => {
					switch (p.data?.metric) {
					case DexaMetric.RegionalComp:
						return <RegionalCard {...p} key={i} />;
					default:
						return <InfoCard {...p} key={i} />;
					}
				})
			}
		</div>
	);
};

export default Summary;
